






import { Component, Vue } from "vue-property-decorator";
import PanelKelolaJenisBerkas from "@/components/pemeriksaan/berkasRm/PanelKelolaJenisBerkas.vue";

@Component({ components: { PanelKelolaJenisBerkas } })
export default class MasterJenisBerkasPage extends Vue {}
